import { Navigate } from "react-router-dom";
import { useAuthStatus } from "./session";
import { AuthSplash } from "./AuthSplash";
import { ForgotPasswordScreen } from "./ForgotPasswordScreen";
import { AUTH_ENABLED } from "./config";

/* The /forgot-password route. Public, like /login and /signup — an already
 * authenticated viewer is bounced home; anonymous or unverified users (who may
 * legitimately want to reset) see the screen. When auth is disabled there's no
 * password flow, so it redirects to the dashboard. */
export function ForgotPasswordRoute() {
  if (!AUTH_ENABLED) return <Navigate to="/" replace />;

  return <ForgotPasswordGate />;
}

function ForgotPasswordGate() {
  const { status } = useAuthStatus();

  if (status === "loading") return <AuthSplash />;

  if (status === "authenticated") return <Navigate to="/" replace />;

  return <ForgotPasswordScreen />;
}
